import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tracking-page-integrations-widget',
  templateUrl: './tracking-page-integrations-widget.component.html',
  styleUrls: ['./tracking-page-integrations-widget.component.scss', '../../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageIntegrationsWidgetComponent implements OnInit {
  @Input() formGroup: FormGroup;

  constructor() {}

  ngOnInit(): void {}
}
